import { render, staticRenderFns } from "./PlotList.vue?vue&type=template&id=b65e8e98&"
import script from "./PlotList.vue?vue&type=script&lang=js&"
export * from "./PlotList.vue?vue&type=script&lang=js&"
import style0 from "./PlotList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports